import urn from 'decorators/urn';

export default (resource: string) => target => urn('$', target.serviceName, resource)(target);